import { Util } from './utilities'
import { GlobalData } from './globalData'
import jwt_decode from 'jwt-decode'
declare var gtag;

declare global {
  interface Window {
    _hsq: any;
    hsConversationsSettings: any;
    HubSpotConversations: any;
    hsConversationsOnReady: any;
  }
}

export const Sesion = {
  /** @description Valida la sesion y retorna los datos de usuario */
  async login(): Promise<boolean> {
    const ticketFromStorage: string | null = localStorage.getItem('token');
    const ticketFromCookie = Util.getCookie('jwt_token');
    const token: string = localStorage.getItem('token');
    Util.deleteCookie('jwt_token');
    const ticket = ticketFromStorage || ticketFromCookie;
    // Validación final
    if (!ticket && !token) {
      return false;
    } else if (token) {
      return true
    }
    try {
      const jwtResponse = await this.getToken({ ticket })

      if (!jwtResponse && !jwtResponse['perfil']) {
        throw new Error(
          'Ocurrió un problema al obtener la respuesta del servidor. ' +
          JSON.stringify(jwtResponse)
        )
      }

      let perfil = jwtResponse['perfil']['result']

      if (perfil.length > 0) {
        perfil = jwt_decode(perfil)
      }

      jwtResponse['datosUsuario']['perfil'] = perfil
      localStorage.setItem(
        'rutEmpresa',
        jwtResponse['datosUsuario']['rutEmpresa']
      )
      localStorage.setItem('email', jwtResponse['datosUsuario']['email'])
      localStorage.setItem('token', jwtResponse['token']['datos']['token'])
      localStorage.setItem('rut', jwt_decode(jwtResponse['token']['datos']['token'])['clientId'])
      localStorage.setItem('userData', JSON.stringify(jwtResponse['datosUsuario']['result']))


      console.log("rut: " + localStorage.getItem('rut'));


      gtag('event', 'virtual_page_view', {
        path: '/ingresar',
        producto: 'AutoFactoring',
        categoria: 'Login - Ingresar',
        subCategoria: 'Ingresar',
        clientCI: localStorage.getItem('rut')
      });

      console.log("Inicia llamada GlobalData.init()");
      await GlobalData.init()
      console.log("Fin llamada GlobalData.init()");

      /*var email = jwtResponse['datosUsuario']['result']['email'];
      var rut = jwtResponse['datosUsuario']['result']['rutEmpresa'];
      this.addHubSpotTracking(email, rut)
      await this.initHubSpotChat(email)*/
      this.redirectHome()
    } catch (e) {
      console.error("sesionts: ", e)
      return false
    }

    return true
  },

  async getToken(bodyObject: object): Promise<object> {
    const url = `${process.env.API}/api/sso/solicitar-token`
    const body = JSON.stringify(bodyObject)
    const method = 'POST'
    const headers = {
      'Content-Type': 'application/json'
    }

    return fetch(url, {
      method,
      headers,
      body
    })
      .then((response) => response.json())
      .catch((e) => {
        console.error(e)
      })
  },

  redirectHome() {
    history.pushState(null, '', '/')
  },


  addHubSpotTracking(_email: string, _rutEmpresa: string) {
    const _hsq = window._hsq = window._hsq || [];
    _hsq.push(["identify", {
      email: _email,
      rut: _rutEmpresa
    }]);

    /* _hsq.push(["trackCustomBehavioralEvent", {
       name: "pe20222912_loging",
       properties: {
         email: _email,
         rut: _rutEmpresa
       }
     }]);*/
  },

  /**
* @description
* Inicializa el chat de HubSpot para registrar el usuario.
*/
  async initHubSpotChat(email: string) {

    window.hsConversationsSettings = {
      loadImmediately: false
    }
    let data = await this.getVisitorIdentification()
    console.info("token hubspot:", data)
    if (data !== null) {
      window.hsConversationsSettings = {
        identificationEmail: email,
        identificationToken: data["token"]
      };

      if (window.HubSpotConversations) {
        console.log('The api is ready already');
        window.HubSpotConversations.widget.load();
      } else {
        window.hsConversationsOnReady = [
          () => {
            console.log('Now the api is ready');
            window.HubSpotConversations.widget.load();
          },
        ];
      }
    }

  },
  /**
  * @description
  * LLamada al servicio del BFF que obtiene el token de HubSpot.
  */
  async getVisitorIdentification(): Promise<object> {
    try {
      const url = `${process.env.API}/api/hubspot/visitor-identification`
      const data = localStorage.getItem("userData")
      const token = localStorage.getItem("token")
      const { email, nombre, apellidoPaterno } = JSON.parse(data)
      const response = await fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.           
        headers: {
          "Content-Type": "application/json",
          "Authorization": token,
        },
        body: JSON.stringify({ email: email, firstName: nombre, lastName: apellidoPaterno }), // body data type must match "Content-Type" header
      });
      return response.json();
    } catch (e) {
      console.info("error hubspot token:", e)
      return null
    }
  }
}
